import OmeMessageState, {
    OmeMessageResponseStatus,
    RevokeExpirePermissions,
} from '../store/schema/OmeMessageState';
import { getTimestamp, owaDate } from 'owa-datetime';

export default function getParsedOmeMessageStatus(stampedOmeMessageState: string): OmeMessageState {
    if (stampedOmeMessageState) {
        let omeMessageState = {
            permissions: RevokeExpirePermissions.None,
            revoked: false,
            expired: false,
            revocationDate: null,
            revokedBy: null,
            responseState: OmeMessageResponseStatus.None,
        };

        try {
            const messageStateObject = JSON.parse(stampedOmeMessageState);
            if (messageStateObject.Permissions == 1 /*User has revoke permission*/) {
                omeMessageState.permissions = RevokeExpirePermissions.Revocable;
            }
            if (messageStateObject.Permissions == 2 /*User has expire permission*/) {
                omeMessageState.permissions = RevokeExpirePermissions.Expirable;
            }
            omeMessageState.revoked = messageStateObject.IsRevoked;
            omeMessageState.expired = messageStateObject.IsExpired;
            if (messageStateObject.RevocationDate) {
                const owadateObject = owaDate('UTC', messageStateObject.RevocationDate);
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS2322 (33,17): Type 'Date' is not assignable to type 'null'.
                // @ts-expect-error
                omeMessageState.revocationDate = new Date(getTimestamp(owadateObject));
            }
            omeMessageState.revokedBy = messageStateObject.RevokedBy;
        } catch (e) {
            // Invalid response string. Failed to parse JSON.
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2322 (41,13): Type 'null' is not assignable to type 'OmeMessageState'.
            // @ts-expect-error
            return null;
        }

        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (47,9): Type '{ permissions: RevokeExpirePermissions; revoked: boolean; expired: boolean; revocationDate: null; revokedBy: null; responseState: OmeMessageResponseStatus; }' is not assignable to type 'OmeMessageState'.
        // @ts-expect-error
        return omeMessageState;
    }

    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (53,5): Type 'null' is not assignable to type 'OmeMessageState'.
    // @ts-expect-error
    return null;
}
